import React from 'react';

const Spinner = () => {
    return (
        <div className="d-flex align-items-center justify-content-center w-100" style={{'height': '100vh'}}>
          <div className="spinner-border" role="status"></div>
        </div>
    );
};

export default Spinner;